<template>
    <div>
        <app-header></app-header>
        <router-view class="container-fluid topMargin"></router-view>
    </div>
</template>

<script>
//    import vueToast from 'vue-toast';
    import ToastAlert from '../../../../Banet/errorsAndNotifications/ToastAlert.vue';
    import Header from '../../components/layout/Header.vue';
    import { translationMixin } from '../../../../Banet/mixins/translationMixin.js'
    import { alertMixin } from '../../../../Banet/mixins/alertMixin.js'
    import BanetInfo from '../../../../Banet/errorsAndNotifications/BanetInfo.vue';
    import BanetWarning from '../../../../Banet/errorsAndNotifications/BanetWarning.vue';
    import { userMixin } from '../../../../Banet/mixins/userMixin.js'

    import enLocale from 'element-ui/lib/locale/lang/en';
    import deLocale from 'element-ui/lib/locale/lang/de';
    import locale from 'element-ui/lib/locale';

    export default {
        mixins: [translationMixin, alertMixin, userMixin],
        components: {
//            vueToast: vueToast,
            toastAlert: ToastAlert,
            appHeader: Header,
            banetInfo: BanetInfo,
            banetWarning: BanetWarning
        },
        sockets:{
            connect: function () {
                console.log('socket connected')
            },
            disconnect: function(data){
                console.log("socket.disconnect");
                this.$store.dispatch('setErrors', this.getTranslation('lbl_connection_backend_lost'));
            },
            tokenExpired: function(){
                this.$store.dispatch('logOut');
//                alert('Log out!!!');
            },
            translationUpdated: function(){
              // console.log("socket.translationUpdated");
              this.setLanguage();
            },
            permissionDenied: function(data){
                // console.log("socket.permissionDenied");
                this.$store.dispatch('setErrors', data);
            },
            translation: function(data){
                // !!! check is it needed ???
               // console.log("socket.translation");
               this.$store.commit('SET_TRANSLATION', data);
            }
        },
        data: function(){
            return {
                alertData: {},
                infoMessage: [],
                warningMessage: [],
                isHtml: true,
                staticLink: true,

                // toast
//                maxToasts: 6,
//                position: 'top left',
//                theme: 'error', // info warning error success
//                timeLife: 3000,
//                closeBtn: false
            }
        },
        computed: {
            messageList: function(){
                return this.chatMessages;
            },
            appErrorsActive: function(){
                // toast, eliminate other warnings
//                return false;

                this.warningMessage = this.$store.getters.getErrorMessages;
                if(this.translations[this.warningMessage]){
                    this.warningMessage = this.translations[this.warningMessage];
                }
                return this.$store.getters.errorsActive;
            }
        },
        methods: {
            closeAlert: function(){
                this.infoMessage = [];
                this.alertInfo(0, 'close');
            },
            closeAlertWarning: function(){
                this.$store.dispatch('unsetErrors');
                this.warningMessage = [];
                this.appErrorsActive = false;
            }
        }
    }
</script>

<style>

    /*.vue-toast_message {*/
        /*padding: 15px 22px 15px 10px;*/
        /*color: white;*/
        /*font-family: inherit;*/
        /*margin-left: -5px;*/
    /*}*/
    /*.vue-toast-manager_container.\--top {*/
        /*top: 30px;*/
    /*}*/
    /*.vue-toast-manager_container.\--bottom {*/
        /*bottom: 10px;*/
    /*}*/
    /*.vue-toast-manager_container.\--left {*/
        /*left: 0px;*/
    /*}*/
    /*.vue-toast-manager_container.\--right {*/
        /*right: 0px;*/
    /*}*/
    /*.vue-toast-manager_toasts {*/
        /*position: relative;*/
    /*}*/

</style>


// WEBPACK FOOTER //
// Dashboard.vue?4085d2e6